import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

export default function ConfirmDialog({
  open,
  title = "Confirmar",
  description = "¿Estás seguro?",
  children = null,
  onConfirm,
  onCancel,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  confirmColor = "primary",
}) {
  return (
    <Dialog open={Boolean(open)} onClose={onCancel} aria-labelledby="confirm-dialog-title" fullWidth maxWidth="xs">
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        {description && <DialogContentText>{description}</DialogContentText>}
        {children}
      </DialogContent>
      <DialogActions sx={{ flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" }, gap: 1 }}>
        <Button onClick={onCancel} color="inherit" sx={{ width: { xs: "100%", sm: "auto" } }}>{cancelText}</Button>
        <Button onClick={onConfirm} variant="contained" color={confirmColor} autoFocus sx={{ width: { xs: "100%", sm: "auto" } }}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
